module.exports = new Promise(resolve => {
              const remoteUrl = 'https://crm.kingwork.vn/remoteEntry.js?t=' + Date.now();
              const script = document.createElement('script');
              script.src = remoteUrl;
              script.onload = () => {
                const proxy = {
                  get: (request) => window.crmRemote.get(request),
                  init: (arg) => {
                    try {
                      return window.crmRemote.init(arg);
                    } catch(e) {
                      console.log('remote container already initialized');
                    }
                  }
                }
                resolve(proxy);
              }
              script.onerror = (error) => {
                console.error('error loading remote entry', error);
                resolve({
                   get: () => Promise.reject(error),
                   init: () => Promise.reject(error),
                });
              }
              document.head.appendChild(script);
            });